import { ConfigProvider, App } from "antd";
import { UserModalType } from "helpers/constants/users";
import ChangeUserRoleModal, { UserData } from "./ChangeUserRoleModal";
import { CreateUserModal } from "./CreateUserModal";
import ResetUserPasswordModal from "./ResetUserPasswordModal";
import UserDeleteModal from "./UserDeleteModal";
import styles from "./style.module.scss";

interface UserModalManagerProps {
  activeModal: UserModalType | null;
  onClose: () => void;
  selectedUser?: UserData | null;
  onRefresh?: () => void;
}

const UserModalManager = ({
  activeModal,
  onClose,
  selectedUser = null,
  onRefresh,
}: UserModalManagerProps) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: '"Inter", sans-serif',
        },
        components: {
          Modal: {
            titleFontSize: 18,
            titleColor: "var(--new-text-on-primary)",
            contentBg: "var(--new-neutral-cards-300)",
            paddingContentHorizontal: 16,
            paddingMD: 15,
          },
          Form: {
            itemMarginBottom: 0,
            labelColor: "var(--new-text-on-primary)",
            labelFontSize: 14,
            labelHeight: 14,
            verticalLabelPadding: "0 0 8px",
          },
          Input: {
            colorText: "var(--new-text-on-primary)",
            fontSize: 14,
            paddingBlock: 4,
            paddingInline: 12,
            controlHeight: 48,
            activeBorderColor: "var(--new-primary-blue-500)",
            hoverBorderColor: "vavar(--new-primary-blue-500)",
            colorTextDisabled: "var(--new-text-on-surface-500)",
            colorBgContainerDisabled: "var(--new-neutral-background-100)",
          },
          Select: {
            selectorBg: "var(--new-neutral-cards-300)",
            colorText: "var(--new-text-on-primary)",
            colorBorder: "var(--new-neutral-900)",
            colorIcon: "var(--new-text-on-primary)",
            controlHeight: 32,
          },
        },
      }}
      form={{
        requiredMark: (label, { required }) => (
          <>
            {label}
            {required && <div className={styles.requiredMark}>*</div>}
          </>
        ),
      }}
    >
      <App>
        <CreateUserModal
          close={onClose}
          isOpen={activeModal === UserModalType.CREATE_USER}
          onRefresh={onRefresh}
        />
        <ChangeUserRoleModal
          isOpen={activeModal === UserModalType.CHANGE_ROLE}
          onClose={onClose}
          user={selectedUser}
          onRefresh={onRefresh}
        />
        <ResetUserPasswordModal
          isOpen={activeModal === UserModalType.CHANGE_PASSWORD}
          onClose={onClose}
          user={selectedUser}
        />
        <UserDeleteModal
          user={selectedUser}
          onClose={onClose}
          isOpen={activeModal === UserModalType.DELETE_USER}
          onRefresh={onRefresh}
        />
      </App>
    </ConfigProvider>
  );
};

export default UserModalManager;
